import React, { useEffect } from "react";

import MainListView from "features/itemLists/MainListView/MainListView";
import PlanItemsContainer from "shared/itemLists/listTypes/plan/PlanItemsContainer.shared";
import ActItemsContainer from "shared/itemLists/listTypes/act/ActItemsContainer.shared";
import DoneItemsContainer from "shared/itemLists/listTypes/done/DoneItemsContainer.shared";

import MainLoader from "features/itemLists/MainListView/MainLoader";

import ListTypeSelector from "shared/itemLists/MainListView/ListTypeSelector.shared";
import CursorItemsCoordinator from "features/itemLists/CursorItemsCoordinator";

import { getInitialIndex } from "../../itemLists/CursorItemsCoordinator/functions/cursorFunctions";

import {
  getPlanHeightsAndTimes,
  getActHeightsAndTimes,
  getDoneHeightsAndTimes,
} from "shared/itemLists/redux/selectors/getHeightsAndTimes";

import {
  removeEmptyDay,
  setHasEmptyDay,
  fetchPlan,
  setNeedsScrollAlignment,
} from "shared/itemLists/redux/itemListsSlice";
import { bindActionCreators } from "redux";
import store from "glassRedux/store";
import connect from "glassRedux/connect";

export function MainListViewShared(props) {
  const {
    setHasEmptyDay,
    newTask,
    hasBlankTask,
    setHasBlankTask,
    setCursorIndex,
    listType,
    needsReload,
    fetchPlan,
  } = props;

  useEffect(() => {
    if (hasBlankTask && newTask.name !== "") {
      setHasBlankTask(false);
      setHasEmptyDay(false);
    }
    if (!hasBlankTask && newTask && newTask.initiated && newTask.name === "") {
      setHasBlankTask(true);
      if (props.planItems[newTask.position].empty === "true") {
        setHasEmptyDay(true);
      }
    }
  }, [newTask, hasBlankTask]);

  useEffect(() => {
    if (needsReload && listType !== "Done") {
      fetchPlan();
    }
    if (listType === "Done") {
      setCursorIndex(getInitialIndex(props.doneItems));
      store.dispatch(
        setNeedsScrollAlignment({ position: "auto", behavior: "auto" })
      );
    }
  }, [listType]);

  function relevantList({onScroll, listRef, renderCursor, scrollGutterHeight}) {
    let relevantProps = props
    if(onScroll){
      relevantProps = {...relevantProps, 
                      onScroll: onScroll, 
                      listRef: listRef, 
                      scrollGutterHeight,
                      renderCursor}
    }
    switch (props.listType) {
      case "Plan":
        return <PlanItemsContainer {...relevantProps} />;
      case "Act":
        return <ActItemsContainer {...relevantProps} />;
      case "Done":
        return <DoneItemsContainer {...relevantProps} />;
    }
  }

  function relevantHeightsAndTimes() {
    switch (props.listType) {
      case "Plan":
        return getPlanHeightsAndTimes(store.getState().itemLists);
      case "Act":
        return getActHeightsAndTimes(store.getState().itemLists);
      case "Done":
        return getDoneHeightsAndTimes(store.getState().itemLists);
    }
  }
  function body() {
    return (
      <>
        <MainLoader />
        <CursorItemsCoordinator
          animatedIndexHelper={props.animatedIndexHelper}
          heightAndTimeArray={relevantHeightsAndTimes()}
          cursorIndex={props.cursorIndex}
          setCursorIndex={props.setCursorIndex}
          selectedDate={props.selectedDate}
          setSelectedDate={props.setSelectedDate}
          dateHelper={props.dateHelper}
          removeEmptyDay={props.removeEmptyDay}
          hasBlankTask={hasBlankTask}
          setHasBlankTask={setHasBlankTask}
          newTask={newTask}
          addEmptyDaysOnClick={listType === "Plan"}
          happyPlaceDistanceType={listType === "Done" ? "short" : "medium"}
          hideCursor={listType === "Done"}
          renderItemsList={relevantList}
        />
      </>
    );
  }

  const footer = (
    <ListTypeSelector
      listType={props.listType}
      setListType={props.setListType}
    />
  );

  return <MainListView {...{ body, footer }} />;
}

function mapStateToProps(state) {
  return {
    newTask: state.itemLists.newTask,
    needsReload: state.itemLists.needsReload,
    doneItems: state.itemLists.doneItems,
    hasEmptyDay: state.itemLists.insertStatus.hasEmptyDay,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { removeEmptyDay, setHasEmptyDay, fetchPlan },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(MainListViewShared);
